import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0db1958&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mixin/loginForm.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./index.scss?vue&type=style&index=1&id=b0db1958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0db1958",
  null
  
)

export default component.exports